import {FC} from 'react';
import { LineItemDto, QuoteDto } from '../../../dtos';
import { ListAlt } from '@mui/icons-material';
import { Dialog, DialogTitle, Typography, DialogContent, DialogActions, Button } from '@mui/material';
import { QuoteLineItemSelectList } from './QuoteLineItemSelectList';

export interface IAddOrderReviewLineItemDialogProps {
    open: boolean;
    onClose: () => void;
    quote: QuoteDto;
    onAddQuoteLineItem: (quoteLineItem: LineItemDto) => void;
    onAddCustomLineItem: () => void;
    disableAddCustomLineItem?: boolean;
};

export const AddOrderReviewLineItemDialog: FC<IAddOrderReviewLineItemDialogProps> = ({
    open,
    onClose,
    quote,
    onAddQuoteLineItem,
    onAddCustomLineItem,
    disableAddCustomLineItem
}) => {
    return (
        <Dialog onClose={onClose} open={open} maxWidth='lg' fullWidth>
            <DialogTitle sx={{ backgroundColor: 'primary', color: '#ffffff' }}>
                <Typography variant='h2'>
                    <ListAlt /> Quote Price List
                </Typography>
            </DialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <QuoteLineItemSelectList
                    quote={quote}
                    disableAddCustomLineItem={disableAddCustomLineItem}
                    onAddQuoteLineItem={onAddQuoteLineItem}
                    onAddCustomLineItem={onAddCustomLineItem}
                />
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={onClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};